import { render, staticRenderFns } from "./InformationOverlay.vue?vue&type=template&id=19d5875b"
import script from "./InformationOverlay.vue?vue&type=script&lang=js"
export * from "./InformationOverlay.vue?vue&type=script&lang=js"
import style0 from "./InformationOverlay.vue?vue&type=style&index=0&id=19d5875b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports